import { getUrlsText, TShareLink } from './fdr-share-overlay.types';
import { TBookmarkInfo } from './fdr-use-share-links.types';

const DOUBLE_NEW_LINE = decodeURIComponent(`%0D%0A%0D%0A`);

export const facebook = (
  toShare: string | TBookmarkInfo[]
): TShareLink | undefined => {
  if (Array.isArray(toShare)) return undefined;

  return {
    icon: `facebook-logo`,
    apiLink: `https://facebook.com/sharer.php?u=${encodeURIComponent(toShare)}`,
  };
};
export const twitter = (
  title: string,
  toShare: string | TBookmarkInfo[]
): TShareLink | undefined => {
  if (Array.isArray(toShare)) return undefined;

  return {
    icon: `x-logo`,
    apiLink: `https://twitter.com/intent/tweet?text=${encodeURIComponent(
      title
    )}&url=${encodeURIComponent(toShare)}`,
  };
};
export const whatsapp = (
  toShare: string | TBookmarkInfo[]
): { icon: string; apiLink: string; tooltip: string; charNum?: number } => {
  const urlPrefix = `https://api.whatsapp.com/send/?phone&text=`;

  if (!Array.isArray(toShare)) {
    return {
      icon: `whatsapp-logo`,
      apiLink: `${urlPrefix}${encodeURIComponent(toShare)}`,
      tooltip: `share.overlay.button.pdfInfo.tooltip.whatsapp`,
    };
  }

  const [sharedText, charNum] = getUrlsText(toShare, urlPrefix.length);
  return {
    icon: `whatsapp-logo`,
    apiLink: `${urlPrefix}${encodeURIComponent(sharedText)}`,
    tooltip: `share.overlay.button.pdfInfo.tooltip.whatsapp`,
    charNum,
  };
};
export const mail = (
  title: string,
  toShare: string | TBookmarkInfo[],
  body: (text: string) => string
): { icon: string; apiLink: string; charNum?: number; tooltip: string } => {
  const urlPrefix = `mailto:?subject=${encodeURIComponent(title)}&body=`;

  if (!Array.isArray(toShare)) {
    return {
      icon: `mail`,
      apiLink: `${urlPrefix}${encodeURIComponent(body(toShare))}`,
      tooltip: `share.overlay.button.pdfInfo.tooltip.mail`,
    };
  }

  const getLink = pdfs =>
    `${urlPrefix}${encodeURIComponent(body(title + DOUBLE_NEW_LINE + pdfs))}`;

  const [pdfs, charNum] = getUrlsText(toShare, getLink('').length);

  return {
    icon: `mail`,
    apiLink: getLink(pdfs),
    charNum,
    tooltip: `share.overlay.button.pdfInfo.tooltip.mail`,
  };
};

const downloadLink = (link: string) => `/api/pdf/download?file=${link}`;
export const download = (
  title: string,
  toShare: string | TBookmarkInfo[]
): TShareLink => {
  if (Array.isArray(toShare)) {
    return {
      icon: `download`,
      apiLink: undefined,
      func(e) {
        e.preventDefault();

        toShare.forEach(item => {
          setTimeout(() => {
            window.open(downloadLink(item.link));
          });
        });
      },
    };
  }

  return {
    name: title,
    icon: `download`,
    apiLink: downloadLink(toShare),
  };
};
